import React from "react";
import { Header } from "../../components/Header";
import CloudOriginalBody from "../../blocks/cloudOriginalBody";
import { HomeTryOn } from "../../blocks/home-try-on";
import "./styles.less";
import { ApplicationBanner } from "../../blocks/application-banner";
import { useTranslation } from "react-i18next";
import { Footer } from "../../components/FooterV2";
import { Helmet } from "react-helmet";
import { Notice } from "../../components/Notice";
export const CloudOriginal = (props) => {
  const { t } = useTranslation();
  return (
    <div className="cloud-original-integration-page">
      <Helmet>
        <title>
          云原生身份平台-云原生身份管理项目-云原生项目优势-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="light" />
      <ApplicationBanner
        name="cloudOriginal"
        title={t("cloudOriginal.banner.title")}
        subtitle={t("cloudOriginal.banner.subtitle")}
        character={t("cloudOriginal.banner.character")}
        // img="//files.authing.co/authing-website/cloud-native-banner-img-v2.png"
        img={t("cloudOriginal.banner.img")}
        alt="云原生身份服务"
      />
      <CloudOriginalBody />
      <HomeTryOn />
      <Footer />
    </div>
  );
};
